<div ng-controller="activityConfigController as vm" class="modal-view">
    
</div>